import styled from 'styled-components'
import { AgentColorPallette } from '../../configs/colorPallete'

export const ShowSnackbarStyle = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 16px;

  box-sizing: border-box;
  max-width: 768px;
  margin: 0 auto;
  padding: 16px;
  color: ${props => props.theme.white};
  text-align: center;

  visibility: ${props => props.visible ? 'visible' : 'hidden'} !important;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
  z-index: 999999999;

  .snackbar-box {
    padding: 16px;
    border-radius: 12px;
    background-color: ${props => props.error ? AgentColorPallette.lighterRed : AgentColorPallette.crusieGreen};
    color: ${props => props.error ? AgentColorPallette.fireRed : AgentColorPallette.earthGreen};
    font-size: 12px;
    font-weight: 800;
    text-align: left;

    .icon-container {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .snackbar-close {
    position: relative;
    display: inline-block;
    width: 16px;
    height: 16px;
    overflow: hidden;
    cursor: pointer;
    ::before,
    ::after {
      content: '';
      position: absolute;
      height: 2px;
      width: 100%;
      top: 50%;
      left: 0;
      margin-top: -1px;
      border-radius: 2px;
      background: ${props => props.error ? AgentColorPallette.fireRed : AgentColorPallette.earthGreen};
    }
    ::before { transform: rotate(45deg); }
    ::after { transform: rotate(-45deg); }
  }
`
